import { toast } from 'react-toastify';

export const NETWORK_TOAST_ID = 'servicezone-network-error';
let outageReported = false;
let lastNotice = null;

export const reportNetworkFailure = (message, { background = false, mutating = false } = {}) => {
  if (background && (document.hidden || outageReported)) return;
  if (!mutating && lastNotice !== null && Date.now() - lastNotice < 15000) return;
  if (toast.isActive(NETWORK_TOAST_ID)) return;
  outageReported = true;
  lastNotice = Date.now();
  toast.error(message, { toastId: NETWORK_TOAST_ID });
};

export const markServerReachable = () => {
  outageReported = false;
  toast.dismiss(NETWORK_TOAST_ID);
};
